/**
 * ? @description : Create Student Profile By Admin
 */

// Dependencies
import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// CSS
import "../../../../css/StudentByAdmin.css";

// Axios Component
import Axios from "../../../../axios/Axios";

// Snackbar Component
import { showSnackbar } from "../../../redux/features/appSlice";
import { LoadingButton } from "@mui/lab";

function StudentByAdmin() {
  // * Redux Variable
  const dispatch = useDispatch();

  // * Router Variable
  const navigate = useNavigate();

  // * Logged User Name
  const username = sessionStorage.getItem("username");

  // * State Variables
  const [loading, setLoading] = useState(false);
  const [studentData, setStudentData] = useState({
    student_name: "",
    whatsappno: "",
    sponser_name: "",
    sponser_contactno: "",
    sponser_address: "",
    sponser_email: "",
    sponser_email_otp_verified: false,
    student_age: "",
    education: "",
    level_reading_skill: "",
    class_contactno: "",
    student_status: "active",
    role: "student",
    group_status: "ungrouped",
    student_mapped_status: "unmapped",
    is_terms_agreed: null,
    spoken_language_1: "",
    spoken_language_2: null,
    spoken_language_3: null,
    spoken_language_4: null,
    spoken_language_5: null,
    spoken_language_6: null,
    group_id: null,
    group_name: null,
    map_id: null,
    medium_education: '',
    parent_name: null,
    parent_contactno: null,
    mapped_to_teacher: null,
    batch_member_id: null,
    created_by: username,
  });

  const chosenLanguages = [
    studentData.spoken_language_1,
    studentData.spoken_language_2,
    studentData.spoken_language_3,
    studentData.spoken_language_4,
    studentData.spoken_language_5,
    studentData.spoken_language_6,
  ].filter(data => data);

  const [studentValidation, setStudentValidation] = useState({
    isInvalidStudentName: false,
    isInvalidStudentNameFormate: false,
    isInvalidClassContactNo: false,
    isInvalidSponsorEmail: false,
    isInvalidSponsorEmailOTP: false,
    isInvalidStudentWhatsapp: false,
    isInvalidClassContactNoFormate: false,
    isInvalidStudentWhatsappFormate: false,
    isInvalidSponsorName: false,
    isInvalidSponsorNameFormate: false,
    isInvalidSponsorNumber: false,
    isInvalidSponsorNumberFormate: false,
    isInvalidSponsorAddress: false,
    isInvalidStudentAge: false,
    isInvalidStudentLanguage: false,
    isInvalidStudentEducation: false,
    isInvalidStudentReadingSkill: false,
    isInvalidStudentReadingSkillFormate: false,
  });
  const [otherField, setOtherField] = useState(false)

  // TODO : Mobile number Validation Pattern
  const checkInvalidNumber = (number) => {
    var pattern = new RegExp(
      /^\d+$/
    );
    var result = pattern.test(number);
    return !result;
  }
  // TODO : Name field validation pattern 

  const checkInvalidName = (name) => {
    var pattern = new RegExp(/^[a-zA-Z]+(?: [a-zA-Z]+)*$/);
    var result = pattern.test(name);
    return !result;
  }

  // TODO : Email Validation Pattern
  const checkInvalidEmail = (email) => {
    var pattern = new RegExp(
      /^(([\w.+-]+)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    var result = pattern.test(email);
    return !result;
  };

  // TODO : Form Validation
  const studentFormValidation = () => {
    var submitButton = true;
    var invalidStudentName = false;
    var invalidStudentNameFormate = false;
    var invalidClassContactNo = false;
    var invalidStudentWhatsapp = false;
    var invalidClassContactNoFormate = false;
    var invalidStudentWhatsappFormate = false;
    var invalidSponsorName = false;
    var invalidSponsorNameFormate = false;
    var invalidSponsorNumber = false;
    var invalidSponsorNumberFormate = false;
    var invalidSponsorAddress = false;
    var invalidStudentAge = false;
    var invalidStudentLanguage = false;
    var invalidStudentEducation = false;
    var invalidStudentReadingSkill = false;
    var invalidStudentReadingSkillFormate = false;
    var invalidSponsorEmail = false;
    var invalidSponsorEmailOTP = false;

    if(checkInvalidEmail(studentData.sponser_email)){
      invalidSponsorEmail = true;
      submitButton = false;
    }

    if(!studentData.sponser_email_otp_verified){
      invalidSponsorEmailOTP = true;
      submitButton = false;
    }

    if (
      studentData.student_name.length === 0 ||
      studentData.student_name.length > 30
    ) {
      invalidStudentName = true;
      submitButton = false;
    } else if (checkInvalidName(studentData.student_name)) {
      invalidStudentNameFormate = true;
      submitButton = false;
    }

    if (!(studentData.class_contactno.length === 10)) {
      invalidClassContactNo = true;
      submitButton = false;
    } else {
      if (checkInvalidNumber(studentData.class_contactno)) {
        invalidClassContactNoFormate = true;
        submitButton = false;
      }
    }

    if (!(studentData.whatsappno.length === 10)) {
      invalidStudentWhatsapp = true;
      submitButton = false;
    } else {
      if (checkInvalidNumber(studentData.whatsappno)) {
        invalidStudentWhatsappFormate = true;
        submitButton = false;
      }
    }

    if (
      studentData.sponser_name.length === 0 ||
      studentData.sponser_name.length > 30
    ) {
      invalidSponsorName = true;
      submitButton = false;
    } else if (checkInvalidName(studentData.sponser_name)){
      invalidSponsorNameFormate = true;
      submitButton = false;
    }

    if (!(studentData.sponser_contactno.length === 10)) {
      invalidSponsorNumber = true;
      submitButton = false;
    } else {
      if (checkInvalidNumber(studentData.sponser_contactno)) {
        invalidSponsorNumberFormate = true;
        submitButton = false;
      }
    }

    if (studentData.sponser_address.length === 0) {
      invalidSponsorAddress = true;
      submitButton = false;
    }

    if (
      studentData.student_age.length === 0 ||
      parseInt(studentData.student_age) < 8 ||
      parseInt(studentData.student_age) > 71
    ) {
      invalidStudentAge = true;
      submitButton = false;
    }

    if (
      studentData.spoken_language_1.length === 0 ||
      studentData.spoken_language_1.length > 30
    ) {
      invalidStudentLanguage = true;
      submitButton = false;
    }

    if (
      studentData.education.length === 0 ||
      studentData.education.length > 50
    ) {
      invalidStudentEducation = true;
      submitButton = false;
    }

    if (studentData.medium_education.length === 0) {
      invalidStudentReadingSkill = true;
      submitButton = false;
    } else if (checkInvalidName(studentData.medium_education)) {
      invalidStudentReadingSkillFormate = true;
      submitButton = false;
    }

    setStudentValidation({
      ...studentValidation,
      isInvalidStudentName: invalidStudentName,
      isInvalidStudentNameFormate: invalidStudentNameFormate,
      isInvalidClassContactNo: invalidClassContactNo,
      isInvalidStudentWhatsapp: invalidStudentWhatsapp,
      isInvalidClassContactNoFormate: invalidClassContactNoFormate,
      isInvalidStudentWhatsappFormate: invalidStudentWhatsappFormate,
      isInvalidSponsorName: invalidSponsorName,
      isInvalidSponsorNameFormate: invalidSponsorNameFormate,
      isInvalidSponsorNumber: invalidSponsorNumber,
      isInvalidSponsorNumberFormate:invalidSponsorNumberFormate,
      isInvalidSponsorAddress: invalidSponsorAddress,
      isInvalidStudentAge: invalidStudentAge,
      isInvalidStudentLanguage: invalidStudentLanguage,
      isInvalidStudentEducation: invalidStudentEducation,
      isInvalidStudentReadingSkill: invalidStudentReadingSkill,
      isInvalidStudentReadingSkillFormate:invalidStudentReadingSkillFormate,
      isInvalidSponsorEmail: invalidSponsorEmail,
      isInvalidSponsorEmailOTP: invalidSponsorEmailOTP
    });
    return submitButton;
  };

  // ? Post Method : Create Student Profile By Admin
  async function postData() {
    try {
      setLoading(true)
      let finaldata = {
        ...studentData,
        is_under_eighteen: parseInt(studentData.student_age) < 18 ? true : false,
      };

      let options = {
        method: "POST",
        url: "/student",
        auth: true,
        data: finaldata,
      };

      const response = await Axios(
        options.method,
        options.url,
        options.auth,
        options.data
      );

      if (response.status === 201 && response.data.message === "Student information created successfully!") {
        // console.log(response);
        setLoading(false)
        dispatch(
          showSnackbar({
            message: "Student data submitted successfully !",
            severity: "success",
          })
        );

        setTimeout(() => {
          navigate("/category/students")
        }, 2000)

      }
    } catch (error) {
      setLoading(false)
      if (error.status === 400) {
        dispatch(
          showSnackbar({
            message: "Student profile already exists, Try with different Name and Phone number",
            severity: "error",
          })
        );
      } else {
        dispatch(
          showSnackbar({
            message: "Error occurred while creating student profile. Please try again later.",
            severity: "error",
          })
        );
      }

    }
  }

  /******************************************* verify email *********************************************/

    const [ otp, setOtp ] = useState("");

    const [ isVerifyOtpTriggered, setIsVerifyOtpTriggered ] = useState({
        isSuccess: false,
        isLoading: false,
        isError: false,
        data: null
    });


    const [ verifyOtp, setVerifyOtp ] = useState({
        isLoading: false,
        isError: false,
        isSuccess: false,
        data: null
    });

    
    const [ isEmailVerified, setEmailVerified ] = useState({
      isLoading: false,
      isError: false,
      isSuccess: false,
      data: null
    })

    const triggerOTPRequest = async () => {
        try{

            setIsVerifyOtpTriggered(prev => ({ ...prev, isLoading: true }));

            let options = {
                method: "POST",
                url: "/teacher/send/otp",
                auth: true,
                data: {
                    email: studentData.sponser_email,
                    is_teacher: false
                },
            };
        
            const response = await Axios(
                options.method,
                options.url,
                options.auth,
                options.data
            );

            if(response.status === 200){
                setIsVerifyOtpTriggered(prev => ({ ...prev, isLoading: false, isError: false, isSuccess: true, data: response.data }));
                dispatch(
                  showSnackbar({
                      message: "OTP sent successfully, Please check your Email",
                      severity: "success",
                  })
                );
            }

        }catch(error){
            console.log(error);
            setIsVerifyOtpTriggered(prev => ({ ...prev, isLoading: false, isError: true, data: null, isSuccess: false }));
            dispatch(
              showSnackbar({
                  message: error?.data?.message,
                  severity: "error",
              })
            );
        }   
    }

    useEffect(() => {
        if(otp.length === 6){
            (async () => {
                try{

                    setVerifyOtp(prev => ({ ...prev, isLoading: true, isError: false, data: null, isSuccess: false }));

                    let options = {
                        method: "POST",
                        url: "/teacher/verify/email",
                        auth: true,
                        data: {
                            email: studentData.sponser_email,
                            otp: otp
                        },
                    };
                
                    const response = await Axios(
                        options.method,
                        options.url,
                        options.auth,
                        options.data
                    );

                    if(response.status === 200){
                        setVerifyOtp(prev => ({ ...prev, isLoading: false, isError: false, isSuccess: true, data: response.data }));
                        setStudentData(prev => ({ ...prev, sponser_email_otp_verified: true }))
                        dispatch(
                          showSnackbar({
                              message: "OTP Verified Successfully",
                              severity: "success",
                          })
                        );
                    }

                    
                }catch(error){
                    console.log(error);
                    setVerifyOtp(prev => ({ ...prev, isLoading: false, isError: true, data: null, isSuccess: false }));
                    dispatch(
                        showSnackbar({
                            message: error?.data?.message,
                            severity: "error",
                        })
                    );
                }
            })()
        }
    }, [otp]);

    useEffect(() => {
      if(!checkInvalidEmail(studentData.sponser_email)){
        (async () => {
            try{

              setEmailVerified(prev => ({ ...prev, isLoading: true, isError: false, data: null, isSuccess: false }));

              let options = {
                  method: "POST",
                  url: "/teacher/check/email/verification",
                  auth: true,
                  data: {
                    email: studentData.sponser_email,
                    is_teacher: false
                  },
              };
          
              const response = await Axios(
                  options.method,
                  options.url,
                  options.auth,
                  options.data
              );

              if(response.status === 200){
                  setEmailVerified(prev => ({ ...prev, isLoading: false, isError: false, isSuccess: true, data: response.data.verifiedEmail ? "verified" : "unverified" }));
                  setStudentData(prev => ({ ...prev, sponser_email_otp_verified: response.data.verifiedEmail }))
              }

            }catch(error){
                console.log(error);
                setEmailVerified(prev => ({ ...prev, isLoading: false, isError: true, data: null, isSuccess: false }));
            }
        })()
      }else{
        setEmailVerified(prev => ({ ...prev, isLoading: false, isError: false, isSuccess: false, data: false }));
        setStudentData(prev => ({ ...prev, sponser_email_otp_verified: false }))
      }
    }, [studentData.sponser_email])

    useEffect(() => {
      if(verifyOtp.isSuccess){
        setStudentValidation({
          ...studentValidation,
          isInvalidSponsorEmailOTP: false,
        });
      }
    }, [verifyOtp.isSuccess]);

    useEffect(() => {
      setStudentData(prev => ({ ...prev, sponser_email_otp_verified: false }));
      setOtp("")
      setIsVerifyOtpTriggered(prev => ({ ...prev, isLoading: false, isError: false, data: null, isSuccess: false }));
      setVerifyOtp(prev => ({ ...prev, isLoading: false, isError: false, data: null, isSuccess: false }));
    }, [studentData.sponser_email])

  return (
    <div>
      <Row>
        <Col
          xs={{ span: 10, offset: 1 }}
          sm={{ span: 8, offset: 2 }}
          md={{ span: 8, offset: 2 }}
          lg={{ span: 8, offset: 2 }}
          xl={{ span: 6, offset: 3 }}
        >
          {/* Title */}
          <h1 className="mt-3 student-title">
            Let's Teach English - Student Registration Form
          </h1>

          {/* Form */}
          <Form>
            <Form.Group className="mb-3 student-form">
              <Form.Label>
                Name <span style={{ color: "red" }}>*</span>
              </Form.Label>

              <Form.Control
                type="text"
                name="student_name"
                placeholder="Name"
                value={studentData.student_name}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    student_name: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidStudentName: false,
                    isInvalidStudentNameFormate:false,
                  });
                }}
                isInvalid={studentValidation.isInvalidStudentName || studentValidation.isInvalidStudentNameFormate}
              />

              <Form.Control.Feedback type="invalid">
                {studentValidation.isInvalidStudentName ? 'Student name is mandatory and should be less than 30 characters.' : ''}
                {studentValidation.isInvalidStudentNameFormate ? 'Student name should consist only of alphabetical values.' : ''}

                {/* Student name is mandatory and should be less than 30 characters. */}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>
                Phone Number <span style={{ color: "red" }}>*</span>
              </Form.Label>

              <Form.Control
                type="tel"
                name="class_contactno"
                placeholder="Number"
                value={studentData.class_contactno}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    class_contactno: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidClassContactNo: false,
                    isInvalidClassContactNoFormate:false,
                  });
                }}
                isInvalid={studentValidation.isInvalidClassContactNo || studentValidation.isInvalidClassContactNoFormate}
              />

              <Form.Control.Feedback type="invalid">
                {studentValidation.isInvalidClassContactNo ? ' Student number is mandatory and must contains 10 digits.':''}
               {studentValidation.isInvalidClassContactNoFormate ? 'Student phone number is not valid': ''}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>
              Student's WhatsApp number (This number will be used to send the material for the classes)&nbsp;
                <span style={{ color: "red" }}>*</span>
                <br />
                <p style={{ color: "gray", fontSize: "10px" }}>
                  Note : Please copy the above number if same number is used for
                  WhatsApp
                </p>
              </Form.Label>

              <Form.Control
                type="tel"
                name="whatsappno"
                placeholder="WhatsApp Number"
                value={studentData.whatsappno}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    whatsappno: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidStudentWhatsapp: false,
                    isInvalidStudentWhatsappFormate:false,
                  });
                }}
                isInvalid={studentValidation.isInvalidStudentWhatsapp || studentValidation.isInvalidStudentWhatsappFormate}
              />

              <Form.Control.Feedback type="invalid">
                {studentValidation.isInvalidStudentWhatsapp ? 'Student WhatsApp number is mandatory and must contains 10 digits.' : ''}
                {studentValidation.isInvalidStudentWhatsappFormate ? 'Student WhatsApp number is not valid':''}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>
              Sponsor's Name (Sponsor is anyone who registers a student)&nbsp;
                <span style={{ color: "red" }}>*</span>
              </Form.Label>

              <Form.Control
                type="text"
                name="sponser_name"
                placeholder="Sponsor's Name"
                value={studentData.sponser_name}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    sponser_name: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidSponsorName: false,
                    isInvalidSponsorNameFormate:false,
                  });
                }}
                isInvalid={studentValidation.isInvalidSponsorName || studentValidation.isInvalidSponsorNameFormate}
              />

              <Form.Control.Feedback type="invalid">
                {studentValidation.isInvalidSponsorName ? 'Sponsor name is mandatory and should be less than 30 characters.': ''}
                {studentValidation.isInvalidSponsorNameFormate ? 'Sponsor name should consist only of alphabetical values.': ''}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>
                Sponsor's Phone Number&nbsp;
                <span style={{ color: "red" }}>*</span>
              </Form.Label>

              <Form.Control
                type="tel"
                name="sponser_contactno"
                placeholder="Sponsor's Number"
                value={studentData.sponser_contactno}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    sponser_contactno: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidSponsorNumber: false,
                    isInvalidSponsorNumberFormate:false,
                  });
                }}
                isInvalid={studentValidation.isInvalidSponsorNumber || studentValidation.isInvalidSponsorNumberFormate}
              />

              <Form.Control.Feedback type="invalid">
                {studentValidation.isInvalidSponsorNumber ? 'Sponsor number is mandatory and must contains 10 digits.': ''}
               {studentValidation.isInvalidSponsorNumberFormate ? 'Sponsor number is not valid.': ''}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>
                Email ID <span style={{ color: "red" }}>*</span>
              </Form.Label>

              <Form.Control
                type="email"
                name="email"
                placeholder="Your Email Id"
                // style={{ width: "250px" }}
                value={studentData.sponser_email}
                onChange={(event) => {
                  setStudentData({ ...studentData, sponser_email: event.target.value.toLocaleLowerCase() });
                  setIsVerifyOtpTriggered(prev => ({ ...prev, isLoading: false, isError: false, isSuccess: false, data: null }));
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidSponsorEmail: false,
                  });
                }}
                isInvalid={studentValidation.isInvalidSponsorEmail}
              />
                {isEmailVerified.data === "unverified" && !studentData.sponser_email_otp_verified && 
                    <LoadingButton 
                        onClick={triggerOTPRequest} 
                        loading={isVerifyOtpTriggered.isLoading}
                        className="mt-1" 
                        size="small" 
                        type="button"
                    >
                        {isVerifyOtpTriggered.isSuccess ? "Resend" : "Verify OTP"}
                    </LoadingButton>
                }

                {studentData.sponser_email_otp_verified && <span className="mt-1 text-success">Email Verified Successfully</span>}
              

              <Form.Control.Feedback type="invalid">
                Enter valid Email Id
              </Form.Control.Feedback>
            </Form.Group>

            {isVerifyOtpTriggered.isSuccess && !studentData.sponser_email_otp_verified &&
                <Form.Group className="mb-3 form-info">
                    <Form.Label>
                        Enter OTP <span style={{ color: "red" }}>*</span>
                    </Form.Label>
        
                    <Form.Control
                        type="text"
                        name="otp"
                        placeholder="Enter OTP"
                        value={otp}
                        isInvalid={studentValidation.isInvalidSponsorEmailOTP}
                        onChange={(e) => {
                          setStudentValidation({
                            ...studentValidation,
                            isInvalidSponsorEmailOTP: false,
                          });
                          if (e.target.value.length <= 6) {
                            setOtp(e.target.value);
                          }
                        }}
                        onKeyDown={(e) => {
                            if (otp.length >= 6 && e.key !== "Backspace") {
                                e.preventDefault();
                            }
                        }}
                    />

                    {verifyOtp.isLoading && <LoadingButton loading></LoadingButton>}
                    {verifyOtp.isSuccess && <span className="mt-1 text-success">Email Verified Successfully</span>}
                    {verifyOtp.isError && <span className="mt-1 text-danger">Invalid OTP</span>}

                    <Form.Control.Feedback type="invalid">
                      Email must be verified
                    </Form.Control.Feedback>
                </Form.Group>
            }

            <Form.Group className="mb-3 student-form">
              {/* <Form.Label>
                Sponsor's Residence&nbsp;
                <span style={{ color: "red" }}>*</span>
              </Form.Label> */}
                 <Form.Label>
                City of Residence&nbsp;
                <span style={{ color: "red" }}>*</span>
              </Form.Label> 

              {/* <Form.Check
                type="radio"
                name="sponser_address"
                label="APR Villas"
                value="APR Villas"
                reverse
                onChange={(event) => {
                  setOtherField(false)
                  setStudentData({
                    ...studentData,
                    sponser_address: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidSponsorAddress: false,
                  });
                }}
                isInvalid={studentValidation.isInvalidSponsorAddress}
              />

              <Form.Check
                type="radio"
                name="sponser_address"
                label="APR Towers"
                value="APR Towers"
                reverse
                onChange={(event) => {
                  setOtherField(false)
                  setStudentData({
                    ...studentData,
                    sponser_address: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidSponsorAddress: false,
                  });
                }}
                isInvalid={studentValidation.isInvalidSponsorAddress}
              />

              <Form.Check
                type="radio"
                label="Others"
                // value="others"
                name="sponser_address"
                onClick={() =>{ 
                  setOtherField(true)
                  setStudentData({
                    ...studentData,
                    sponser_address: '',
                  });
                }}
                 checked={otherField} 
                reverse
                isInvalid={studentValidation.isInvalidSponsorAddress}
              /> */}
              <Form.Control
                type="text"
                name="sponser_address"
                value={studentData.sponser_address}
                onChange={(event) => {
                  
                  setStudentData({
                    ...studentData,
                    sponser_address: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidSponsorAddress: false,
                  });
                }}
                isInvalid={studentValidation.isInvalidSponsorAddress}
              />


              <Form.Control.Feedback type="invalid">
                Sponsor address is mandatory.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>
                Student's Age<span style={{ color: "red" }}>*</span>
                <br />
                <p style={{ color: "gray", fontSize: "10px" }}>
                Note : Student should be over 8yrs to be able to enroll in this programme
                </p>
              </Form.Label>

              <Form.Control
                name="student_age"
                type="number"
                min={8}
                max={60}
                placeholder="Age"
                value={studentData.student_age}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    student_age: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidStudentAge: false,
                  });
                }}
                isInvalid={studentValidation.isInvalidStudentAge}
              />

              <Form.Control.Feedback type="invalid">
                Student Age is mandatory and must be greater than or equal to
                age 8 and not over 70.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>
                Spoken Language - 1&nbsp;
                <span style={{ color: "red" }}>*</span>
                <br />
                <p style={{ color: "gray", fontSize: "10px", margin: "0" }}>
                English, Hindi, Kannada, Malayalam, Tamil, Telugu, Urdu
                </p>
              </Form.Label>

              {/* <Form.Control
                type="name"
                name="spoken_language_1"
                placeholder="First Language"
                value={studentData.spoken_language_1}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_1: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidStudentLanguage: false,
                  });
                }}
                isInvalid={studentValidation.isInvalidStudentLanguage}
              /> */}

              <Form.Select
                aria-label="Default select example"
                value={studentData.spoken_language_1}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_1: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidStudentLanguage: false,
                  });
                }}
                isInvalid={studentValidation.isInvalidStudentLanguage}
              >
                <option value="">Select one language</option>
                {[ "English", "Hindi", "Kannada", "Malayalam", "Tamil", "Telugu", "Urdu" ].map(item => (
                  <option disabled={chosenLanguages.some(data => data === item)} key={`spoken-language-1-${item}`} value={item}>{item}</option>
                ))}

              </Form.Select>

              <Form.Control.Feedback type="invalid">
                Spoken Language is mandatory.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>Spoken Language - 2<br />
                <p style={{ color: "gray", fontSize: "10px", margin: "0" }}>
                English, Hindi, Kannada, Malayalam, Tamil, Telugu, Urdu
                </p>
              </Form.Label>

              {/* <Form.Control
                type="name"
                name="spoken_language_2"
                placeholder="Second Language"
                value={studentData.spoken_language_2}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_2: event.target.value,
                  });
                }}
              /> */}

              <Form.Select
                aria-label="Default select example"
                value={studentData.spoken_language_2}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_2: event.target.value,
                  });
                }}
              >
                <option value="">Select one language</option>
                {[ "English", "Hindi", "Kannada", "Malayalam", "Tamil", "Telugu", "Urdu" ].map(item => (
                  <option disabled={chosenLanguages.some(data => data === item)} key={`spoken-language-2-${item}`} value={item}>{item}</option>
                ))}

              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>Spoken Language - 3<br />
                <p style={{ color: "gray", fontSize: "10px", margin: "0" }}>
                English, Hindi, Kannada, Malayalam, Tamil, Telugu, Urdu
                </p>
              </Form.Label>

              {/* <Form.Control
                type="name"
                name="spoken_language_3"
                placeholder="Third Language"
                value={studentData.spoken_language_3}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_3: event.target.value,
                  });
                }}
              /> */}

              <Form.Select
                aria-label="Default select example"
                value={studentData.spoken_language_3}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_3: event.target.value,
                  });
                }}
              >
                <option value="">Select one language</option>
                {[ "English", "Hindi", "Kannada", "Malayalam", "Tamil", "Telugu", "Urdu" ].map(item => (
                  <option disabled={chosenLanguages.some(data => data === item)} key={`spoken-language-3-${item}`} value={item}>{item}</option>
                ))}

              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>Spoken Language - 4<br />
                <p style={{ color: "gray", fontSize: "10px", margin: "0" }}>
                English, Hindi, Kannada, Malayalam, Tamil, Telugu, Urdu
                </p>
              </Form.Label>

              {/* <Form.Control
                type="name"
                name="spoken_language_4"
                placeholder="Fourth Language"
                value={studentData.spoken_language_4}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_4: event.target.value,
                  });
                }}
              /> */}

              <Form.Select
                aria-label="Default select example"
                value={studentData.spoken_language_4}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_4: event.target.value,
                  });
                }}
              >
                <option value="">Select one language</option>
                {[ "English", "Hindi", "Kannada", "Malayalam", "Tamil", "Telugu", "Urdu" ].map(item => (
                  <option disabled={chosenLanguages.some(data => data === item)} key={`spoken-language-4-${item}`} value={item}>{item}</option>
                ))}

              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>Spoken Language - 5<br />
                <p style={{ color: "gray", fontSize: "10px", margin: "0" }}>
                English, Hindi, Kannada, Malayalam, Tamil, Telugu, Urdu
                </p>
              </Form.Label>

              {/* <Form.Control
                type="name"
                name="spoken_language_5"
                placeholder="Fifth Language"
                value={studentData.spoken_language_5}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_5: event.target.value,
                  });
                }}
              /> */}

              <Form.Select
                aria-label="Default select example"
                value={studentData.spoken_language_5}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_5: event.target.value,
                  });
                }}
              >
                <option value="">Select one language</option>
                {[ "English", "Hindi", "Kannada", "Malayalam", "Tamil", "Telugu", "Urdu" ].map(item => (
                  <option disabled={chosenLanguages.some(data => data === item)} key={`spoken-language-5-${item}`} value={item}>{item}</option>
                ))}

              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>Spoken Language - 6<br />
                <p style={{ color: "gray", fontSize: "10px", margin: "0" }}>
                English, Hindi, Kannada, Malayalam, Tamil, Telugu, Urdu
                </p>
              </Form.Label>

              {/* <Form.Control
                type="name"
                name="spoken_language_6"
                placeholder="Sixth Language"
                value={studentData.spoken_language_6}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_6: event.target.value,
                  });
                }}
              /> */}

              <Form.Select
                aria-label="Default select example"
                value={studentData.spoken_language_6}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    spoken_language_6: event.target.value,
                  });
                }}
              >
                <option value="">Select one language</option>
                {[ "English", "Hindi", "Kannada", "Malayalam", "Tamil", "Telugu", "Urdu" ].map(item => (
                  <option disabled={chosenLanguages.some(data => data === item)} key={`spoken-language-6-${item}`} value={item}>{item}</option>
                ))}

              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>
                Highest Level of Education&nbsp;
                <span style={{ color: "red" }}>*</span>
              </Form.Label>

              <Form.Control
                type="text"
                name="education"
                placeholder="Education"
                value={studentData.education}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    education: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidStudentEducation: false,
                  });
                }}
                isInvalid={studentValidation.isInvalidStudentEducation}
              />

              <Form.Control.Feedback type="invalid">
                Education level is mandatory and should not exceeds 50
                characters.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3 student-form">
              <Form.Label>
              Medium of Instruction in School&nbsp;
                <span style={{ color: "red" }}>*</span>
              </Form.Label>

              <Form.Control
                type="text"
                name="medium_of_education"
                placeholder="Medium of Education"
                value={studentData.medium_education}
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    medium_education: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidStudentReadingSkill: false,
                    isInvalidStudentReadingSkillFormate:false
                  });
                }}
                isInvalid={studentValidation.isInvalidStudentReadingSkill || studentValidation.isInvalidStudentReadingSkillFormate}
              />

              <Form.Control.Feedback type="invalid">
                {studentValidation.isInvalidStudentReadingSkill? 'Medium of Education is mandatory and should not exceeds 50 characters.' : ''}
                {studentValidation.isInvalidStudentReadingSkillFormate? 'The student Medium of Education should consist only of alphabetical values.': ''}.
              </Form.Control.Feedback>

              {/* <Form.Check
                type="radio"
                name="level_reading_skill"
                label="Beginner"
                value="Beginner"
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    level_reading_skill: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidStudentReadingSkill: false,
                  });
                }}
                isInvalid={studentValidation.isInvalidStudentReadingSkill}
              />

              <Form.Check
                type="radio"
                name="level_reading_skill"
                label="Intermediate"
                value="Intermediate"
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    level_reading_skill: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidStudentReadingSkill: false,
                  });
                }}
                isInvalid={studentValidation.isInvalidStudentReadingSkill}
              />

              <Form.Check
                type="radio"
                name="level_reading_skill"
                label="Advanced"
                value="Advanced"
                onChange={(event) => {
                  setStudentData({
                    ...studentData,
                    level_reading_skill: event.target.value,
                  });
                  setStudentValidation({
                    ...studentValidation,
                    isInvalidStudentReadingSkill: false,
                  });
                }}
                isInvalid={studentValidation.isInvalidStudentReadingSkill}
              />

              <Form.Control.Feedback type="invalid">
                Reading skill is mandatory.
              </Form.Control.Feedback> */}
            </Form.Group>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "30px",
              }}
            >
              <Button
                type="button"
                variant="light"
                className="student-cancel"
                onClick={() => navigate(-1)}
              >
                CANCEL
              </Button>

              <Button
                type="submit"
                variant="primary"
                className="student-submit"
                onClick={(e) => {
                  e.preventDefault();
                  var isValid = studentFormValidation();
                  if (isValid) postData();
                  else
                    dispatch(
                      showSnackbar({
                        message: "Please fill all the mandatory fields.",
                        severity: "error",
                      })
                    );
                }}
              >
                SUBMIT
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
      {loading && <div id="backdrop">
        <Spinner style={{
          display: "block",
          position: "fixed",
          top: "calc(50% - (58px / 2))",
          right: "calc(50% - (58px / 2))",
        }} animation="border" variant="primary" />
      </div>}
    </div>
  );
}

export default StudentByAdmin;
